import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import Lottie from "lottie-react";
import colorfulConfettiAnimation from "@/common/lottie/ColorfulConfettiBrust.json";
export default function MobileWarrantyPromoCode() {
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full cursor-pointer focus:outline-none mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gap-2 flex items-center rounded-lg border-solid border-[1px] border-[#8E47E0] bg-[#f0f0fc] p-1  hover:bg-[#e8e8f8] transition-colors"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between w-full gap-2 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#484848] text-[14px] font-medium leading-snug"
  }, tShort("warranty/protected_description")), /*#__PURE__*/React.createElement(Lottie, {
    animationData: colorfulConfettiAnimation,
    loop: true,
    className: "w-8 h-8 shrink-0 mx-1"
  })))));
}